import { BcmFile, BcmFileDto } from './bcm-file';
import { parseBcmAuditTimestamp } from '@shared/functions/parse-bcm-audit-timestamp';

export interface BcmNoteDto {
    id: number;
    note: string;
    bcm_files_id?: number | null;
    transcription_text?: string | null;
    file?: BcmFileDto | null;
    insertedOn: string | Date;
    insertedBy: string;
    lastUpdateOn: string | Date;
    lastUpdateBy: string;
}

export class BcmNote {
    id;
    note;
    bcm_files_id: number | null;
    transcription_text: string | null;
    file: BcmFile | null;
    readonly insertedOn: Date | null;
    readonly insertedBy: string;
    readonly lastUpdateOn: Date | null;
    readonly lastUpdateBy: string;

    constructor(bcmNoteDto: BcmNoteDto  = {} as BcmNoteDto) {
        this.id = bcmNoteDto.id;
        this.note = bcmNoteDto.note;
        this.bcm_files_id = bcmNoteDto.bcm_files_id ?? null;
        this.transcription_text = bcmNoteDto.transcription_text ?? null;
        this.file = bcmNoteDto.file ? new BcmFile(bcmNoteDto.file) : null;
        this.insertedOn = parseBcmAuditTimestamp(bcmNoteDto.insertedOn);
        this.insertedBy = bcmNoteDto.insertedBy;
        this.lastUpdateOn = parseBcmAuditTimestamp(bcmNoteDto.lastUpdateOn);
        this.lastUpdateBy = bcmNoteDto.lastUpdateBy;
    }
}
